import React, { useState } from 'react'
import styles from './MethodSelectionModal.module.css'
import brushIcon from '../../assets/icons/brushWhite.svg'
import cameraIcon from '../../assets/icons/cameraWhite.svg'

const MethodSelectionModal = ({ isOpen, onClose, onMethodSelect }) => {
  const [selectedMethod, setSelectedMethod] = useState(null)

  const methods = [
    {
      id: 'draw',
      title: '직접 그리기',
      description: '직접 캔버스에 그린 그림을 통해 심리 상태를 분석합니다.',
      icon: brushIcon,
      iconBoxColor: '#7c3aed'
    },
    {
      id: 'upload',
      title: '업로드 하기',
      description: '직접 종이에 그린 그림을 업로드하여 심리 상태를 분석합니다.',
      icon: cameraIcon,
      iconBoxColor: '#3b82f6'
    }
  ]

  const handleMethodClick = (method) => {
    setSelectedMethod(method)
  }

  const handleStart = () => {
    if (selectedMethod) {
      onMethodSelect(selectedMethod)
    }
  }

  if (!isOpen) return null

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <div className={styles.header}>
          <h2>방식 선택</h2>
          <p>어떤 방식으로 그림을 그리시겠어요?</p>
        </div>

        <div className={styles.methodsGrid}>
          {methods.map((method) => (
            <div
              key={method.id}
              className={`${styles.methodCard} ${
                selectedMethod?.id === method.id ? styles.selected : ''
              }`}
              onClick={() => handleMethodClick(method)}
            >
              <div 
                className={styles.methodIcon}
                style={{
                  backgroundColor: method.iconBoxColor,
                }}
              >
                <img src={method.icon} alt = "method.icon" draggable={false}/>
              </div>
              <div className={styles.methodContent}>
                <h3 className={styles.methodTitle}>{method.title}</h3>
                <p className={styles.methodDescription}>{method.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className={styles.actions}>
          <button 
            className={styles.cancelBtn} 
            onClick={onClose}
          >
            뒤로
          </button>
          <button 
            className={styles.startBtn} 
            onClick={handleStart}
            disabled={!selectedMethod}
          >
            시작하기
          </button>
        </div>
      </div>
    </div>
  )
}

export default MethodSelectionModal

